// // // src/components/widgets/MetricCard.jsx
// // import { Card, CardContent, Typography, Box } from "@mui/material";
// // import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
// // import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
// // import { green, red } from "@mui/material/colors";

// // export default function MetricCard({
// //   title,
// //   value,
// //   change, // ex: -3 ou +5 (nombre)
// //   unit = "", // ex: "min"
// //   subtitle = "On the last 3 days",
// // }) {
// //   const isPositive = change > 0;
// //   const ArrowIcon = isPositive ? ArrowUpwardIcon : ArrowDownwardIcon;
// //   const color = isPositive ? green[600] : red[600];

// //   return (
// //     <Card elevation={0} sx={{ flex: 1, borderRadius: 2 }}>
// //       <CardContent>
// //         <Typography variant="subtitle2" color="text.secondary">
// //           {title}
// //         </Typography>

// //         <Box sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
// //           <Typography variant="h4">
// //             {value} {unit}
// //           </Typography>
// //           <Box sx={{ display: "flex", alignItems: "center", color }}>
// //             <ArrowIcon fontSize="small" />
// //             <Typography variant="body2">{Math.abs(change)}%</Typography>
// //           </Box>
// //         </Box>

// //         <Typography variant="caption" color="text.secondary">
// //           {subtitle}
// //         </Typography>
// //       </CardContent>
// //     </Card>
// //   );
// // }

// // src/components/widgets/MetricCard.jsx
// import React, { useEffect, useState } from "react";
// import { Card, CardContent, Typography } from "@mui/material";

// export default function MetricCard({
//   title,
//   value,
//   unit = "", // ex: "min"
// }) {
//   const [display, setDisplay] = useState(0);

//   useEffect(() => {
//     let start = 0;
//     const duration = 500; // durée totale de l'animation en ms
//     const stepTime = Math.max(Math.floor(duration / value), 20);

//     const timer = setInterval(() => {
//       start += 1;
//       if (start >= value) {
//         setDisplay(value);
//         clearInterval(timer);
//       } else {
//         setDisplay(start);
//       }
//     }, stepTime);

//     return () => clearInterval(timer);
//   }, [value]);

//   return (
//     <Card elevation={0} sx={{ flex: 1, borderRadius: 2 }}>
//       <CardContent>
//         <Typography variant="subtitle2" color="text.secondary">
//           {title}
//         </Typography>
//         <Typography variant="h3">
//           {display} {unit}
//         </Typography>
//       </CardContent>
//     </Card>
//   );
// }

import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography } from "@mui/material";

export default function MetricCard({
  title,
  value,
  unit = "",
  color = "#000", // ← couleur par défaut
}) {
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 500;
    const stepTime = Math.max(Math.floor(duration / (value || 1)), 20);

    const timer = setInterval(() => {
      start += 1;
      if (start >= value) {
        setDisplay(value);
        clearInterval(timer);
      } else {
        setDisplay(start);
      }
    }, stepTime);

    return () => clearInterval(timer);
  }, [value]);

  return (
    <Card
      elevation={0}
      sx={{
        flex: 1,
        borderRadius: 2,
        borderLeft: `4px solid ${color}`, // ← trait coloré
      }}
    >
      <CardContent>
        <Typography variant="subtitle2" sx={{ color, fontWeight: 500 }}>
          {title}
        </Typography>
        <Typography variant="h3">
          {display} {unit}
        </Typography>
      </CardContent>
    </Card>
  );
}
